import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  color?: 'primary' | 'white';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  className = '',
  color = 'primary'
}) => {
  const { t } = useTranslation();
  
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4'
  }[size];

  const colorClasses = {
    primary: 'border-gray-200 border-t-green-600',
    white: 'border-white/30 border-t-white'
  }[color];

  return (
    <div className={`flex justify-center items-center py-4 ${className}`}>
      <div 
        className={`
          ${sizeClasses}
          ${colorClasses}
          animate-spin
          rounded-full
        `}
        aria-label={t('common.loading')}
      />
    </div>
  );
};

export default LoadingSpinner;